import { render, staticRenderFns } from "./CompanyListPage.vue?vue&type=template&id=53aef5e4&"
import script from "./CompanyListPage.vue?vue&type=script&lang=js&"
export * from "./CompanyListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports